import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) => ({
  typography: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));
